import { ModuleExtensions } from '@wix/premium-fed-sdk/@premium-module';
export const DomainSearchSuiteStoreExtension = ModuleExtensions.storeExtension({
  status: undefined,
  isInvokedAction: false,
  error: undefined,
  viewMode: undefined
}, 'domainSearchSuiteStore', {
  useStatus: state => state.status,
  useError: state => state.error,
  useViewMode: state => state.viewMode,
  useIsInvokedAction: state => state.isInvokedAction
}, {
  setViewMode: (_ref, viewMode) => {
    let draft = _ref.draft;
    draft.viewMode = viewMode;
  },
  setStatus: (_ref2, status) => {
    let draft = _ref2.draft;
    draft.status = status;
  },
  setError: (_ref3, error) => {
    let draft = _ref3.draft;
    draft.error = error;
  },
  setIsInvokedAction: (_ref4, isInvokedAction) => {
    let draft = _ref4.draft;
    draft.isInvokedAction = isInvokedAction;
  },
  resetState: _ref5 => {
    let draft = _ref5.draft;
    draft.status = undefined;
    draft.error = undefined;
    draft.isInvokedAction = false;
  }
});
//# sourceMappingURL=DomainSearchSuiteStore.js.map